import { ReactNode } from "react";
import NavIcon from "./navIcon";

export default function TitleHeader({type, children}: {type: string, children: ReactNode}){
    return (
        <header className="title-header">
            {/* <NavIcon type={type} /> */}
            {children}
        </header>
    )
}